import { render } from "./GasData.vue?vue&type=template&id=71bb05c6"
import script from "./GasData.vue?vue&type=script&lang=js"
export * from "./GasData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__